
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import t from "@common/src/i18n/t";
import { priceRulesEl } from "@common/src/utils/verify";

const partsCategory = namespace("parts-category");
const parts = namespace("parts");
const base = namespace("base");
const common_base = namespace("common_base");
@Component({})
export default class Template extends Vue {
  @partsCategory.Action getCategoryList;
  @parts.Action createBrand;
  @parts.Action getPartsBrandList;
  @base.Action getDictionaryList;
  @common_base.Action getSystemValue;
  show = false;
  form: any = {
    partsName: "",
    categoryCode: "",
    purchasePrice: "",
    sellingPrice: "",
    taxRate: "",
    brandCode: "",
    partsUnit: ""
  };
  formRules: any = {
    partsName: [{ required: true, message: t("setting.enter-name-parts"), trigger: "blur" }],
    categoryCode: [{ required: true, message: t("setting.select-parts-classification"), trigger: "blur" }],
    partsUnit: [{ required: true, message: t("v216_6.please-select-a-unit"), trigger: "change" }],
    brandCode: [{ required: true, message: t("v216_6.please-select-a-brand"), trigger: "change" }],
    purchasePrice: [
      {
        required: true,
        validator: (rule, value, callback) => priceRulesEl(value, callback),
        trigger: "blur"
      }
    ],
    sellingPrice: [
      {
        required: true,
        validator: (rule, value, callback) => priceRulesEl(value, callback),
        trigger: "blur"
      }
    ]
  };
  u8cPartTexRate = "";
  categoryList = [];
  async created() {
    this.getBrandList();
    this.getDictionaryList("parts_unit").then(data => {
      this.partsUnitList = data;
    });
    this.getSystemValue("u8c_parts_tax_rate").then(data => {
      this.u8cPartTexRate = data.data.dataValue || "";
    });
    const categoryList = await this.getCategoryList();
    this.categoryList = this.addLeafFlag(categoryList.data || []);
  }
  // 过滤空children
  addLeafFlag(list) {
    const f = function (list) {
      list.forEach(item => {
        if (!item.children || item.children.length < 1) {
          delete item.children;
        } else {
          f(item.children);
        }
      });
    };
    f(list);
    return list;
  }
  categoryCasProps: any = {
    label: "categoryName",
    value: "categoryCode"
  };
  brandList: any = [];
  brandListCopy: any[] = [];
  brandSearchValue: string = ""; // 品牌搜索keyword

  handleSearchBrand(val) {
    if (val) {
      this.brandSearchValue = val;
      this.brandList = this.brandList.filter(item => {
        return item.brandName.includes(val);
      });
    } else {
      this.brandList = this.brandListCopy;
    }
  }
  async addNewBrand() {
    (this.$refs["brandSelect"] as any).blur();
    const data = await this.createBrand({ brandName: this.brandSearchValue });
    this.getBrandList(() => {
      this.$nextTick(() => {
        this.form.brandCode = data.data.brandCode;
      });
    });
  }
  getBrandList(callback?) {
    this.getPartsBrandList().then(data => {
      this.brandList = this.$safeValue(data, "data.list", []);
      this.brandListCopy = data.data.list;
      callback && callback();
    });
  }
  handleConfirm() {
    (this.$refs["tempPartsForm"] as any).validate(valid => {
      if (valid) {
        this.show = false;
        const brandName = this.brandList.find(item => item.brandCode === this.form.brandCode).brandName;
        this.$emit(
          "submit",
          Object.assign(this.form, {
            categoryCode: this.form?.categoryCode?.length
              ? this.form.categoryCode[this.form.categoryCode.length - 1]
              : "",
            partsNameDesc: `${brandName}•${this.form.partsName}`
          })
        );
      }
    });
  }
  open() {
    this.show = true;
    this.$refs["tempPartsForm"] && (this.$refs["tempPartsForm"] as any).resetFields();
  }
  partsUnitList: any = []; // 数据字典-单位
}
